import Messages from "../../component/messages/Messages";
import MMessages from "../../component/mobile/messages/MMessages";


const MESSAGES=()=>{
  return(
    <div className="MESSAGES">
      {window.innerWidth>1000 && <Messages/>}
      {window.innerWidth<1000 && <MMessages/>}
    </div>
  )
}

export default MESSAGES;